import { render, staticRenderFns } from "./PasswordLoginForm.vue?vue&type=template&id=0ccbeaa7&scoped=true&"
import script from "./PasswordLoginForm.vue?vue&type=script&lang=js&"
export * from "./PasswordLoginForm.vue?vue&type=script&lang=js&"
import style0 from "./PasswordLoginForm.vue?vue&type=style&index=0&id=0ccbeaa7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ccbeaa7",
  null
  
)

export default component.exports